var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"index_container"},[_c('div',{staticStyle:{"position":"fixed","top":"0","left":"0","right":"0","z-index":"100"}},[_c('Header')],1),_c('div',{staticStyle:{"flex":"1"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }